import styled from "styled-components";
import { Common } from "@lainco/react-toolbox";

export function Tabs({ tabs, currentTab, onChange }) {
  return (
    <Common.Row cols={tabs.map(() => "auto").join(" ") + " 1fr"} padding="0 1em" gap="0.5em">
      {tabs.map((tab) => (
        <Tab key={tab.id} active={tab.id === currentTab} onClick={() => onChange(tab.id)}>
          {tab.name}
        </Tab>
      ))}
    </Common.Row>
  );
}

const Tab = styled.div`
  padding: 0.5em 0.5em;
  border-bottom: 2px solid ${(props) => (props.active ? "#000" : "transparent")};
  cursor: pointer;
  font-weight: ${(props) => (props.active ? "600" : "400")};
  color: ${(props) => (props.active ? "#000" : "#777")};

  &:hover {
    color: #000;
    border-bottom: 2px solid ${(props) => (props.active ? "#000" : "#aaa")};
  }
`;
